import React, { memo } from 'react';
import ListParagraph from './ListParagraph';
import SubTitleExceptions from './SubTitleExceptions';
import { useTheme } from '@mui/material/styles';

const ListParagraphForExceptions = ({ children }) => {

  const theme = useTheme();

  return (
    <ListParagraph sx={{
      paddingBlockStart: '0.5rem',
      paddingBlockEnd: '0.5rem',
      border: `1px solid ${theme.palette.text.secondary}`,
      borderRadius: '3px',
    }}>
      <SubTitleExceptions /><br />
      {children}
    </ListParagraph>
  );
};

export default memo(ListParagraphForExceptions);
